
import { Component, h, Prop, State,Element } from '@stencil/core';
import { NjRoute } from './NjRoute';
import { NjRouteProperties } from './NjRouteProperties';

@Component({
  tag: 'nj-router'
})
export class NjRouter {
    @State() route: NjRoute
    @Prop() routes: NjRouteProperties[]

    @Element() el: HTMLElement;

    matchRoute(path: string): any {
        const pathParts = path.split("?");
        const matchingRoute = this.routes.find(route => route.path === pathParts[0]);
        if (matchingRoute) {
            let route: NjRoute = new NjRoute(matchingRoute);
            route.params = this.convertParams(pathParts[1], route.params);
            this.route = {...route};
        } else {
            window.location.hash = this.routes[0].path + (pathParts[1] ? '?' + pathParts[1] : '');
        }
    }
    convertParams(queryString: string,params:any): any {
      if(!params){
        params = {}
      }

      if (queryString) {
        let keyValueParts = queryString.split("&")
        for (let i = 0; i < keyValueParts.length; i++) {
          let keyValue = keyValueParts[i].split("=")

          params[keyValue[0]] = decodeURI(keyValue[1])

        }
      }
      return params
    }
    componentWillLoad() {
      if (!window.location.hash) {
        window.location.hash = "/home"
      }

      let self = this
      window.addEventListener('popstate', function () {
        self.matchRoute(this.location.hash.substring(1))
      });

      self.matchRoute(window.location.hash.substring(1))
    }

    render() {
      if (this.route) {
        if (this.route.title) document.title = this.route.title;
        window.scrollTo(0, 0);

        return h(this.route.component, { route: this.route });
      }
    }

}
